export default __webpack_public_path__ + "static/media/beaker.1a85b796.svg";